import { BodyText, TitleText } from 'styling/Typography'
import { AccommodationStep, AccomodationBlockReveiw, AddAccommodationModalContainer, AddAccommodationModalContnet, AddAccommodationModalWrapper, AddAccommodationSteps, BlockContainer, CampContainer, CampOverviewContainer, ColoredSquare, IconContainer } from '../Accommodation.style'
import { Box, Button, colors, Flex, SectionButton } from 'styling/GlobalStyles'
import React, { useState } from 'react'
import { HouseIcon } from '../icons/HouseIcon'
import { Input } from 'components/Input/Input'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { OrangeBlockIcon } from '../icons/OrangeBlockIcon'
import { OrangeRoomIcon } from '../icons/OrangeRoomIcon'
import { OrangeBedIcon } from '../icons/OrangeBedIcon'
import { OrangeHouseIcon } from '../icons/OrangeHouse'
import { SmallOrangeBedIcon } from '../icons/SmalOrangeBedIcon'
import { IAccommodationModalCamp } from 'types/accommodation.interface'
import { PartyIcon } from '../icons/PartyIcon'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { createCamp } from 'features/accommodation/accommodationSlice'

const FirstStep = ({ setCamp, camp }) => {

    const initiateCamp = () => {
        setCamp({
            name: '',
            address: '',
            coordinates: { latitude: null, longitude: null },
            status: null,
            blocks: []
        })
    }


    const NoCampAdded = () => {
        return <Flex column gap='0.5rem' width='100%' height='100%' center justcenter >
            <IconContainer><HouseIcon /> </IconContainer>
            <TitleText>No camp created</TitleText>
            <Button orange onClick={initiateCamp} >Create Camp</Button>
        </Flex>
    }

    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Create Camp</TitleText>
            <TitleText grey >Follow the steps to set up your camp structure</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1 }}  >
            {!camp ? <NoCampAdded /> :
                <Flex column gap='1rem' >
                    <Box>
                        <Flex column gap='1rem' >
                            <Input value={camp.name} onChange={e => setCamp({ ...camp, name: e.target.value })} placeholder='Camp 1...' labelText='Name' nomarg />
                            <Input value={camp.address} onChange={e => setCamp({ ...camp, address: e.target.value })} labelText='Address' placeholder='Main Street 123...' nomarg />
                            <HonestSelectInput onChange={(v: ISelectValue) => setCamp({ ...camp, status: v })} options={[{ label: 'Active', value: 1 }, { label: 'Inactive', value: 2 }]} labelText='Status' />
                        </Flex>
                    </Box>
                </Flex>
            }
        </Box>
    </>
}
const SecondStep = ({ camp, setCamp }) => {
    const initiateBlocks = () => {
        setCamp(prev => {
            return {
                ...prev, blocks: [...prev.blocks, {
                    id: new Date().getTime(),
                    name: 'Blok 1',
                    genderPolicy: null,
                    tierPolicy: null,
                    status: null,
                    rooms: []
                }]
            }
        })
    }

    const NoBlocksAdded = () => {
        return <Flex column gap='0.5rem' width='100%' height='100%' center justcenter >
            <IconContainer><HouseIcon /> </IconContainer>
            <TitleText>No blocks added</TitleText>
            <Button orange onClick={initiateBlocks} >Create Block</Button>
        </Flex>
    }

    const handleSelect = (value: ISelectValue, name: string, blockId: number) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => b.id === blockId ? { ...b, [name]: value } : b)
            }
        })
    }

    const handleInput = (value: string, name: string, blockId: number) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => b.id === blockId ? { ...b, [name]: value } : b)
            }
        })
    }

    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Add Blocks to Camp</TitleText>
            <TitleText grey >Blocks are major subdivisions within your camp</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1, overflow: 'auto' }}  >
            {!camp?.blocks?.length ? <NoBlocksAdded /> : <Flex column gap='1rem' >
                {
                    camp.blocks.map(b => <Box key={b.id} >
                        <Flex column gap='1rem' >
                            <Input value={b.name} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInput(e.target.value, 'name', b.id)} placeholder='Block 1...' labelText='Name' nomarg />
                            <HonestSelectInput defaultValue={b.status?.value} onChange={(v: ISelectValue, n: string) => handleSelect(v, n, b.id)} options={[{ label: 'Active', value: 1 }, { label: 'Inactive', value: 2 }]} labelText='Status' nomarg name='status' />
                            <HonestSelectInput defaultValue={b.genderPolicy?.value} onChange={(v: ISelectValue, n: string) => handleSelect(v, n, b.id)} options={[{ label: 'Male', value: 1 }, { label: 'Female', value: 2 }, { label: 'Both', value: 3 }]} labelText='Gender Policy' nomarg name='genderPolicy' />
                            <HonestSelectInput defaultValue={b.tierPolicy?.value} onChange={(v: ISelectValue, n: string) => handleSelect(v, n, b.id)} options={[{ label: 'VIP', value: 1 }, { label: 'Senior', value: 2 }, { label: 'Junior', value: 3 }, { label: 'Contractor', value: 4 }]} labelText='Tier Policy' nomarg name='tierPolicy' />
                        </Flex>
                    </Box>)
                }
                <Button orange width='100%' mt='32' onClick={initiateBlocks} >Add Another Block</Button>
            </Flex>}
        </Box>
    </>
}
const ThirdStep = ({ camp, setCamp }) => {
    const [selectedBlock, setSelectedBlock] = useState(null)

    const initiateRooms = () => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => {
                    if (b.id === selectedBlock) {
                        return {
                            ...b, rooms: [...b.rooms, {
                                id: new Date().getTime(),
                                name: 'Room ' + (b.rooms.length + 1),
                                capacity: null,
                                status: null,
                                beds: []
                            }]
                        }
                    }
                    return b
                })
            }
        })
    }



    const handleSelect = (value: ISelectValue, roomId: number) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => b.id === selectedBlock ? { ...b, rooms: b.rooms.map(r => r.id === roomId ? { ...r, status: value } : r) } : b)
            }
        })
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>, roomId: number) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => b.id === selectedBlock ? { ...b, rooms: b.rooms.map(r => r.id === roomId ? { ...r, [e.target.name]: e.target.name == 'capacity' ? e.target.valueAsNumber : e.target.value } : r) } : b)
            }
        })
    }

    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Add Rooms to Blocks</TitleText>
            <TitleText grey >Define rooms within each block and set their policies</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1, overflow: 'auto' }}  >
            <Flex column gap='1rem' >
                {
                    camp?.blocks?.map(b => <CampContainer key={b.id} onClick={() => setSelectedBlock(b.id)} active={selectedBlock == b.id} >
                        <CampOverviewContainer>
                            <TitleText>{b.name}</TitleText>
                        </CampOverviewContainer>
                        <BlockContainer style={{ gap: '0.5rem', display: 'flex' }} >
                            <Flex column gap='0.5rem' width='100%'>

                                {b.rooms.map(r => <Box key={r.id} width='100%' style={{ flex: 1 }}>
                                    <Flex column gap='1rem' >
                                        <Input placeholder='Block 1...' value={r.name} onChange={e => handleInput(e, r.id)} name='name' labelText='Name' nomarg />
                                        <Flex between gap='1rem' >
                                            <Input value={r.capacity} onChange={e => handleInput(e, r.id)} placeholder='15' labelText='Capacity' name='capacity' type='number' nomarg />
                                            <HonestSelectInput name='status' defaultValue={r.status?.value} onChange={(v: ISelectValue) => handleSelect(v, r.id)} options={[{ label: 'Active', value: 1 }, { label: 'Inactive', value: 2 }]} labelText='Status' nomarg />
                                        </Flex>
                                    </Flex>
                                </Box>)}
                                <Button orange onClick={initiateRooms} > Add Room </Button>
                            </Flex>
                        </BlockContainer>
                    </CampContainer>)
                }
            </Flex>
        </Box>
    </>

}
const FourthStep = ({ camp, setCamp }) => {

    const [selectedBlock, setSelectedBlock] = useState(null)

    const initiateBed = (roomId) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => {
                    if (b.id === selectedBlock) {
                        return { ...b, rooms: b.rooms.map(r => { if (r.id === roomId) { return { ...r, beds: [...r.beds, { id: new Date().getTime(), name: 'Bed ' + (r.beds.length + 1), status: null }] } } return r }) }
                    }
                    return b
                })
            }
        })
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>, roomId: number, bedId: number) => {
        setCamp(prev => ({
            ...prev,
            blocks: prev.blocks.map(b =>
                b.id === selectedBlock
                    ? {
                        ...b,
                        rooms: b.rooms.map(room =>
                            room.id === roomId
                                ? {
                                    ...room,
                                    beds: room.beds.map(bed =>
                                        bed.id === bedId ? { ...bed, name: e.target.value } : bed
                                    )
                                }
                                : room
                        )
                    }
                    : b
            )
        }))
    }

    const handleSelect = (v: ISelectValue, roomId: number, bedId: number) => {
        setCamp(prev => ({
            ...prev,
            blocks: prev.blocks.map(b =>
                b.id === selectedBlock
                    ? {
                        ...b,
                        rooms: b.rooms.map(room =>
                            room.id === roomId
                                ? {
                                    ...room,
                                    beds: room.beds.map(bed =>
                                        bed.id === bedId ? { ...bed, state: v } : bed
                                    )
                                }
                                : room
                        )
                    }
                    : b
            )
        }))
    }

    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Add Beds to Rooms</TitleText>
            <TitleText grey >Specify how many beds are in each room</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1, overflow: 'auto' }}  >
            <Flex column gap='1rem' >
                <Flex width='100%' wrap gap='1rem' >{camp?.blocks?.map(b => <SectionButton key={b.id} active={selectedBlock === b.id} onClick={() => setSelectedBlock(b.id)} >{b.name}</SectionButton>)}</Flex>
                {selectedBlock && <Box  >
                    {camp.blocks.find(b => b.id === selectedBlock)?.rooms.map(r => <Box style={{ marginTop: '1rem' }} key={r.id} >
                        <TitleText  >{r.name}</TitleText>
                        {r.beds.map(bed => <Flex gap='1rem' mt='16' key={bed.id}>
                            <Input onChange={e => handleInput(e, r.id, bed.id)} value={bed.name} placeholder='Bed 1...' labelText='Name' nomarg />
                            <HonestSelectInput name='state' defaultValue={bed.status?.value} onChange={(v: ISelectValue) => handleSelect(v, r.id, bed.id)} options={[{ label: 'Available', value: 1 }, { label: 'Occupied', value: 2 }, { label: 'Dirty', value: 3 }, { label: 'Blocked', value: 4 }]} labelText='State' nomarg />
                        </Flex>)}

                        <Button orange onClick={() => initiateBed(r.id)} style={{ marginTop: '3rem' }} > Add Bed</Button>
                    </Box>)}
                </Box>}
            </Flex>
        </Box>
    </>
}
const FifthStep = ({ camp }) => {

    const CountCard = ({ name, count }) => {

        const getIcon = () => {
            switch (name) {
                case 'Blocks':
                    return <OrangeBlockIcon />
                case 'Rooms':
                    return <OrangeRoomIcon />
                default:
                    return <OrangeBedIcon />
            }
        }

        return <Box style={{ flex: 1 }} >
            <Flex column gap='1rem'>
                <TitleText weight='bold' > {name}</TitleText>
                <Flex width='100%' between >
                    <ColoredSquare color={colors.paleOrange} width='36px' >{getIcon()}</ColoredSquare>
                    <TitleText size={28} >{count}</TitleText>
                </Flex>
            </Flex>
        </Box>
    }


    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Review and Create</TitleText>
            <TitleText grey >Review your accommodation structure before creating</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1, overflow: 'auto' }}  >
            <Flex width='100%' gap='1rem' >
                <CountCard name='Blocks' count={5} />
                <CountCard name='Rooms' count={5} />
                <CountCard name='Beds' count={5} />
            </Flex>
            <Box style={{ marginTop: '1rem' }} >
                <Flex column >
                    <Flex mb='16' center gap='0.5rem' >
                        <OrangeHouseIcon />
                        <TitleText>{camp.name}</TitleText>
                    </Flex>
                    <BodyText grey >{camp.address}</BodyText>
                    <BodyText style={{ marginTop: 8 }} grey >Address: {camp.address}</BodyText>
                    <Flex column gap='0.5rem' mt='16' >
                        {camp.blocks.map(b => <AccomodationBlockReveiw key={b.id} >
                            <OrangeBlockIcon />
                            <Flex column gap='0.5rem' >
                                <TitleText>{b.name}</TitleText>
                                {b.rooms.map(r => <Flex key={r.id} gap='0.5rem' style={{ borderLeft: '1px solid #8A8A8A', paddingLeft: '0.5rem' }} >
                                    <SmallOrangeBedIcon />
                                    <BodyText grey >{r.name} · {r.beds.length} beds</BodyText>
                                </Flex>)}
                            </Flex>
                        </AccomodationBlockReveiw>)}
                    </Flex>
                </Flex>
            </Box>
        </Box>
    </>
}

export const AddAccommodationModal = ({ closeModal }) => {
    const [active, setActive] = useState(1)
    const [camp, setCamp] = useState<IAccommodationModalCamp>(null)
    const [completed, setCompleted] = useState(false)
    const dispatch = useDispatch<AppDispatch>()

    const Step = ({ number, name }) => {
        return <Flex gap='0.5rem' center >
            <AccommodationStep active={active == number} >{number}</AccommodationStep>
            <BodyText weight='bold' grey={active !== number} >{name}</BodyText>

        </Flex>
    }
    const getSteps = () => {
        switch (active) {
            case 1:
                return <FirstStep camp={camp} setCamp={setCamp} />
            case 2:
                return <SecondStep camp={camp} setCamp={setCamp} />
            case 3:
                return <ThirdStep camp={camp} setCamp={setCamp} />
            case 4:
                return <FourthStep camp={camp} setCamp={setCamp} />
            case 5:
                return <FifthStep camp={camp} />
        }

    }

    const handleNextStep = () => {
        if (active == 5) {
            handleSave()
        } else {
            setActive(prev => prev + 1)
        }

    }

    const handlePreviousStep = () => {
        setActive(prev => prev - 1)
    }


    const Completed = () => {
        return <Box width='530px' >
            <Flex column gap='2rem' center >
                <TitleText size={24} weight='bold' >Accommodation Setup Completed</TitleText>
                <IconContainer color='#1E1E1E' ><PartyIcon /></IconContainer>
                <TitleText>Your accommodation structure has been successfully created. All camps, blocks, rooms, and beds are now ready for assignment.</TitleText>
                <Button orange width100 onClick={closeModal}>Close</Button>
            </Flex>
        </Box>
    }

    const handleSave = async () => {
        const resp = await dispatch(createCamp(camp))
        if (resp.meta.requestStatus === 'fulfilled') {
            setCompleted(true)
        }
    }



    return <AddAccommodationModalWrapper>
        {completed ? <Completed /> : <AddAccommodationModalContainer>
            <AddAccommodationSteps>
                <TitleText weight='bold' size={24} >Create New Accommodation</TitleText>
                <TitleText style={{ marginTop: '1rem' }} >Provide basic information about the accommodation camp</TitleText>
                <Flex mt='32' column gap='2rem' >
                    <Step number={1} name='Create Camp' />
                    <Step number={2} name='Add Blocks to Camp' />
                    <Step number={3} name='Add Rooms to Blocks' />
                    <Step number={4} name='Add Beds to Rooms' />
                    <Step number={5} name='Review & Create' />
                </Flex>
            </AddAccommodationSteps>
            <AddAccommodationModalContnet>
                {getSteps()}
                <Flex width='100%' end='true' gap='1rem' >
                    <Button orange onClick={handlePreviousStep} disabled={active < 2} > Previous Step </Button>
                    <Button orange onClick={handleNextStep} >{active < 5 ? 'Next Step' : 'Create Accommodation'}</Button>
                </Flex>
            </AddAccommodationModalContnet>
        </AddAccommodationModalContainer>}

    </AddAccommodationModalWrapper>
}